export default "__VITE_ASSET__CSW6H1Gt__"